import * as z from "zod";

export const getSignupAutocompleteSuggestions = {
  name: "getSignupAutocompleteSuggestions" as const,
  input: z.object({
    email: z.email(),
    otpId: z.string(),
    passcode: z.string(),
    query: z.string().min(0),
    sessionToken: z.string().optional(),
    countryCode: z.string().optional(),
  }),
  output: z.object({
    suggestions: z.array(
      z.object({ displayText: z.string(), keyToFullObject: z.string() }),
    ),
  }),
};
